export default "__VITE_ASSET__CWPpMIgW__"